import { http } from '../../config/axios'

const findRepresentanteClienteComissao = (idRepresentante: string): Promise<any> => {
  return http
    .get('api/representante-cliente-comissao/find/' + idRepresentante)
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro findRepresentanteClienteComissao', error)
      throw Error(error.response.data)
    })
}

export default findRepresentanteClienteComissao;
